import { render, staticRenderFns } from "./epago-transacciones-corte.vue?vue&type=template&id=6a15e3b8&"
import script from "./epago-transacciones-corte.vue?vue&type=script&lang=js&"
export * from "./epago-transacciones-corte.vue?vue&type=script&lang=js&"
import style0 from "./epago-transacciones-corte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports